import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — cross-junction wall piece: four half-length arms meeting at
// the tile centre (authored as two full crossing runs, along X and along Z).
// Same plaster + baseboard styling as wall-plain.
const PLASTER = "#e8e4dc";
const BASEBOARD = "#c9c2b6";

export const wallCross = defineModel({
  id: "wall-cross",
  batchId: "modern",
  name: "Wall cross junction",
  tags: ["modern", "interior", "structure", "wall", "junction"],
  summary: "A cross junction: four half-length wall arms meeting at the centre.",
  description:
    "The cross piece of the Modern Living wall system: four half-length " +
    "(0.5 m) plastered arms, 0.12 m thick and 2.6 m high, meeting at the " +
    "tile centre — one toward each tile edge. Straight wall tiles continue " +
    "any arm.",
  tiles: { w: 1, h: 1 },
  footprint: 1.4,
  parts(): Part[] {
    return [
      // full run along X (= the +X and -X half-arms)
      { geometry: new THREE.BoxGeometry(1.0, 2.6, 0.12), color: PLASTER, position: [0, 1.3, 0] },
      // full run along Z (= the +Z and -Z half-arms)
      { geometry: new THREE.BoxGeometry(0.12, 2.6, 1.0), color: PLASTER, position: [0, 1.3, 0] },
      // baseboards
      { geometry: new THREE.BoxGeometry(1.0, 0.1, 0.15), color: BASEBOARD, position: [0, 0.05, 0] },
      { geometry: new THREE.BoxGeometry(0.15, 0.1, 1.0), color: BASEBOARD, position: [0, 0.05, 0] },
    ];
  },
  animations: [],
});
